import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteHeroSearchModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteHeroSearchModalContainer" */
      './DeleteHeroSearchModalContainer'
    ),
  loading: LoadingModal,
});
